import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'app-formly-field-radio',
  templateUrl: './formly-field-radio.component.html',
  styleUrls: ['./formly-field-radio.component.scss']
})
export class FormlyFieldRadioComponent extends FieldType
{

}
